import AppConfig from "config";
import axios from "axios";
const jwtToken = localStorage.getItem('access_token');

const CampanhasController = {
    async ListCampaigns() {
        try {
          const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO+`campanhas_page/campanhas`, {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          });
          return response.data.result;
        } catch (error) {
          console.error("Error fetching transcripts:", error);
          throw error;
        }
      },
      async AddCampaigns(campanha_nome, operacao_id) {
        try {
          const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `campanhas_page/campanhas`, {
            campanha_nome: campanha_nome,
            operacao_id: operacao_id
          }, {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          });
          return response.data;
        } catch (error) {
          console.error("Error creating user:", error);
          throw error;
        }
      },
      async DeleteCampaigns(Id) {
        try {
          const response = await axios.delete(
            `${AppConfig.BACKEND_URL_REFATORADO}campanhas_page/campanhas/${Id}`, 
            {
              headers: {
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          console.error("Error deleting user:", error);
          throw error;
        }
      },
      async PutCampaigns(Id, campanha_nome) {
        try {
          const response = await axios.put(
            `${AppConfig.BACKEND_URL_REFATORADO}campanhas_page/campanhas/${Id}`,
            { campanha_nome },
            {
              headers: {
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          console.error("Error updating user:", error);
          throw error;
        }
      },      
    };

export default CampanhasController;